
import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";
import { SMNps, SMQuestionnaire } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class ReportChangePopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: WARNING_POPUP_TYPE }) readonly type!: string;

  showPopup = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  async start() {
    try {
      const { data } = await this.axios.get<string>(API_ROUTES.COMPANY_REPORT_CHANGE);

      this.close();

      if (!data) return;

      const id = Number(data);

      if (!id) return;

      await SMQuestionnaire.openQuestionnaire(id);

      SMNps.removeFromLocalStorage("report_change");
    } catch (e) {
      console.log("ReportChangePopup error:", e);
    }
  }
}
